import { Moment } from 'moment'

export enum State {
  IDLE = 'IDLE',
  PICKING_SCANNING = 'PICKING_SCANNING',
  PICKED = 'PICKED',
  DROP_SCANNING = 'DROP_SCANNING',
  DROP_ACCEPTING_USER_CHOICE = 'DROP_ACCEPTING_USER_CHOICE',
  DROP_BLOCKED_BY_USER = 'DROP_BLOCKED_BY_USER',
}

export enum AlgorithmMode {
  auto = 'Automatic',
  manual = 'Manual',
  manual_locked = 'Manual_Locked',
}

export enum TagRecordMode {
  auto = 'Auto',
  manual = 'Manual',
}

export enum LoadStatus {
  loaded = 'Loaded',
  not_loaded = 'Not_loaded',
}

export enum OperatorChoice {
  no_choice = 'No_choice',
  loaded_confirmed = 'Loaded_confirmed',
  loaded_rejected = 'Loaded_rejected',
}

export enum AlgorithmChoice {
  no_choice = 'No_choice',
  loaded_confirmed = 'Loaded_confirmed',
  loaded_rejected = 'Loaded_rejected',
}

// Mode_choice/Picked_tag_choices/Auto_drop_validation_cancel_request/Drop_tag_choices/Final_confirmation
export enum OperatorActionType {
  picked_tag_choices = 'Picked_tag_choices',
  mode_choice = 'Mode_choice',
  final_confirmation = 'Final_confirmation',
  drop_tag_choices = 'Drop_tag_choices',
  auto_drop_validation_cancel_request = 'Auto_drop_validation_cancel_request',
}

interface ActionBase {
  touareg_uid: string
  state_machine_session_uid: string
  choice_update_date?: string
  operator_action_type: OperatorActionType
  action_uid: string
}

export interface ActionTagChoice extends ActionBase {
  operator_action_type: OperatorActionType.picked_tag_choices
  tags_choices: TagRecord[]
}

export interface ActionModeChoice extends ActionBase {
  operator_action_type: OperatorActionType.mode_choice
}

export interface ActionFinalConfirm extends ActionBase {
  operator_action_type: OperatorActionType.final_confirmation
}

export interface ActionFinalCancel extends ActionBase {
  operator_action_type: OperatorActionType.auto_drop_validation_cancel_request
}

export interface ActionDropTagChoices extends ActionBase {
  operator_action_type: OperatorActionType.drop_tag_choices
  tags_choices: TagRecord[]
}

export interface GenericAction {
  operator_action_type: OperatorActionType
  action_uid: string
  tags_choices?: TagRecord[]
}

export interface TagRecord {
  tag_uid: number | string
  load_status: LoadStatus
  origin: TagRecordMode
  operator_choice: OperatorChoice
  algo_choice: AlgorithmChoice
  gem: any
}
export interface MachineState {
  touareg_uid: string
  state: State
  algorithm_mode: AlgorithmMode
  tags_list: TagRecord[]
  state_machine_session_uid: string
  state_update_date: Moment
  genesis_time: Moment
  countdown_start_date?: Moment
  countdown?: number
  last_action_uid?: string
  last_session?: {
    state: State
    state_machine_session_uid: string
    state_update_date: Moment
    tags_list: TagRecord[]
  }
}

export interface MachineStateTransport {
  content: MachineState
  ping: number
  dateOffset: number
  // initiator: string
  // key: string
  // timestamp: string
  // ttl: string
}
